import { useState } from "react";
import { Images } from "../assets";
import {
  useNavigate
} from "react-router-dom";

const languages = {
  fr: ["Français", "fr"],
  de: ["Deutsch", "de"],
  en: ["English", "en"],
  it: ["Italiano", "it"],
  es: ["Español", "es"],
};

const LanguageSelector = () => {
  const navigate = useNavigate();
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    return localStorage.getItem("language") || "fr"; // Load from localStorage, default to 'fr'
  });

  const [isOpen, setIsOpen] = useState(false);

  // Save language to localStorage and close popup
  const handleSubmit = (key) => {
    setSelectedLanguage(key);
    setIsOpen(false);
    ["/en", "/fr", "/es", "/it", "/de"].forEach((path) => {
      if (window.location.pathname.startsWith(path)) {
        navigate("/" + key + window.location.pathname.replace(path, ""));
        window.location.reload();
      }
    });
  };

  return (
    <div
      className="relative group"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <div
        className="flex items-center gap-2 cursor-pointer group-hover:text-orange transition-colors duration-200"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="uppercase">{languages[selectedLanguage][1]}</span>
        <img
          src={Images.LANG}
          alt="Sélection langue"
          className="transition-transform duration-200 ease-in-out group-hover:rotate-[360deg]"
        />
      </div>

      {/* Dropdown Content */}
      {isOpen && (
        <div className="absolute left-1/2 transform -translate-x-1/2 top-full pt-2 pb-2 w-20 bg-headerFooter shadow-lg rounded-lg transition-opacity duration-200 opacity-100 visible">
          {Object.entries(languages).map(([key, item]) => (
            <p
              key={key}
              className={`block px-4 py-2 cursor-pointer uppercase ${
                selectedLanguage === key
                  ? "text-orange"
                  : "text-white hover:text-orange/75"
              }`}
              onClick={() => handleSubmit(key)}
            >
              {item[1]}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
